import React from 'react';

const SvgSchedules = props => (
  <svg width={'100%'} viewBox="0 0 32 32" {...props}>
    <defs>
      <style>
        {
          '.schedules_svg__a,.schedules_svg__b{fill:none}.schedules_svg__a{stroke:#acacac;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'
        }
      </style>
    </defs>
    <g transform="translate(-29 -585)">
      <path
        className="schedules__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        d="M33 594h24"
      />
      <circle
        className="schedules__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        cx={6}
        cy={6}
        r={6}
        transform="translate(47 603)"
      />
      <path
        className="schedules__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        d="M53 607v2h2M43 610H33v-21h24v10M42 598h1M42 602h1M42 606h1M47 598h1M47 602h1M52 598h1M52 602h1M37 602h1M37 606h1"
      />
      <path className="schedules_svg__b" d="M29 585h32v32H29z" />
      <path className="schedules_svg__b" d="M29 585h32v32H29z" />
    </g>
  </svg>
);

export default SvgSchedules;
